// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-center {
    padding: 1rem;
}

.help-center .p-tabview-panels {
    padding: 1.5rem 0;
}

.faq-container {
    padding: 0 1rem;
}

.faq-container h1 {
    color: var(--text-color);
    margin-bottom: 2rem;
    font-size: 1.5rem;
    text-align: center;
}

.faq-accordion .p-accordion-header-link {
    padding: 1.25rem;
    font-weight: 600;
}

.faq-accordion .p-accordion-content {
    padding: 1.25rem;
    line-height: 1.5;
}

.footer-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}

/* Custom styling for tabs */
.help-center .p-tabview .p-tabview-nav {
    border-width: 0 0 2px 0;
}

.help-center .p-tabview .p-tabview-nav li .p-tabview-nav-link {
    padding: 1rem 1.5rem;
    font-weight: 600;
}

.help-center .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    border-color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/FAQ.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".help-center {\r\n    padding: 1rem;\r\n}\r\n\r\n.help-center .p-tabview-panels {\r\n    padding: 1.5rem 0;\r\n}\r\n\r\n.faq-container {\r\n    padding: 0 1rem;\r\n}\r\n\r\n.faq-container h1 {\r\n    color: var(--text-color);\r\n    margin-bottom: 2rem;\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.faq-accordion .p-accordion-header-link {\r\n    padding: 1.25rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.faq-accordion .p-accordion-content {\r\n    padding: 1.25rem;\r\n    line-height: 1.5;\r\n}\r\n\r\n.footer-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n}\r\n\r\n/* Custom styling for tabs */\r\n.help-center .p-tabview .p-tabview-nav {\r\n    border-width: 0 0 2px 0;\r\n}\r\n\r\n.help-center .p-tabview .p-tabview-nav li .p-tabview-nav-link {\r\n    padding: 1rem 1.5rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.help-center .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\r\n    border-color: var(--primary-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
